@for (toast of toastService.toasts; track toast) {
<ngb-toast
 
  [autohide]="true"
  [delay]="toast.delay || 5000"
  [class]="toast.type || 'info'"
  (hiddden)="toastService.remove(toast)"
  >{{ toast.body }}</ngb-toast
>
}
